var _defineProperty = require("@babel/runtime/helpers/defineProperty");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evaluate - evaluate getHullEmployeesBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const hullID = await evaluateSource(source.hullID, content, parentContentPath, transientContext, nativeFunctions);
  if (hullID === undefined) {
    return undefined;
  }
  const querySource = {
    type: 'queryEntityBehavior',
    entityName: 'Form',
    properties: ['content'],
    equals: {
      'formType/identifier': 'hull',
      id: hullID
    }
  };
  const hullRows = await evaluateSource(querySource, content, parentContentPath, transientContext, nativeFunctions);
  if (!hullRows || hullRows.length === 0) {
    return undefined;
  }
  return hullRows.reduce((acc, item) => {
    const hullContentString = item.content;
    const _JSON$parse = JSON.parse(hullContentString),
      _JSON$parse$general = _JSON$parse.general,
      _JSON$parse$general2 = _JSON$parse$general === void 0 ? {} : _JSON$parse$general,
      _JSON$parse$general2$ = _JSON$parse$general2.employees,
      employees = _JSON$parse$general2$ === void 0 ? {} : _JSON$parse$general2$;
    return _objectSpread(_objectSpread({}, employees), acc);
  }, {});
};
module.exports = {
  evaluate
};